import { render } from "./HomeSection.vue?vue&type=template&id=2d0bc9b5"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=2d0bc9b5&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__